import { render } from "./Waste.vue?vue&type=template&id=f0c0d90a&scoped=true"
import script from "./Waste.vue?vue&type=script&lang=js"
export * from "./Waste.vue?vue&type=script&lang=js"

import "./Waste.vue?vue&type=style&index=0&id=f0c0d90a&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c0d90a"]])

export default __exports__